import check from "../img/check.svg"
import about from "../img/about.png"
import { useSpring, animated } from 'react-spring'

export const About = () =>{

 
    return(
         <section id = "about"  className="about container1 flex">
        <img  src={about}/>
        <div id = "about" className="about-right">
            <h2>We Provide Many<br/> Features You Can Use</h2>
            <h3>You can explore the features that we provide with fun<br/> and have their own functions each feature.</h3>
            <div className="about-flex">
                <img src={check}/>
                <p>Powerfull online protection.</p>
            </div>
            <div className="about-flex">
                <img src={check}/>
                <p>Internet without borders.</p>
            </div>
            <div className="about-flex">
                <img src={check}/>
                <p>Supercharged VPN</p>
            </div>
            <div className="about-flex">
                <img src={check}/>
                <p>No specific time limits.</p>
            </div>
        </div>
    </section>
    )
   
}